import { render, staticRenderFns } from "./ChatbotsUserManagement.vue?vue&type=template&id=be07f73e&lang=pug"
import script from "./ChatbotsUserManagement.vue?vue&type=script&lang=js"
export * from "./ChatbotsUserManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be07f73e')) {
      api.createRecord('be07f73e', component.options)
    } else {
      api.reload('be07f73e', component.options)
    }
    module.hot.accept("./ChatbotsUserManagement.vue?vue&type=template&id=be07f73e&lang=pug", function () {
      api.rerender('be07f73e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/ChatbotsUserManagement.vue"
export default component.exports